import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса возврата Resource.Aqsi (C4b, `AqsiRefundEndpoints`) через Gateway.
 * Деньги, чек и отмена возврата — ТЕ ЖЕ ручки продажи C3b (`sales/{id}/pay`…):
 * их адреса — `AQSI_SALE_URLS`. rid — сегмент пути каждого запроса (D-064).
 */
const resource = (resourceId: string) => `/api/aqsi/v1/resources/${ridSegment(resourceId)}`

export const AQSI_REFUND_URLS = {
  refunds: (resourceId: string) => `${resource(resourceId)}/refunds`,
  /** RP-FB74: возврат по слипу исходной оплаты БЕЗ чека - создание и отправка одним нажатием человека (один POST к кабинету). */
  slipRefund: (resourceId: string) => `${resource(resourceId)}/refunds/slip`,
  /** RP-FB74: слипы покупки кассы (сумма, время, уже возвращено) для выбора слипа; `?deviceId=`. */
  slipRefundSlips: (resourceId: string) => `${resource(resourceId)}/refunds/slip/slips`,
} as const
